import { render, staticRenderFns } from "./MortgageWatch.vue?vue&type=template&id=456fbc2f&"
import script from "./MortgageWatch.vue?vue&type=script&lang=js&"
export * from "./MortgageWatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports